import { Injectable, Optional, Inject, Signal, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Storefront } from '../models';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, Subject, take, tap } from 'rxjs';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class StorefrontsService {
  ActiveStorefront: WritableSignal<Storefront | undefined> = signal<Storefront | undefined>(undefined);

  constructor(
    private http: HttpClient,
    @Optional()
    @Inject(BASE_URL)
    private BASE_URL: string
  ) {}

  getActiveStorefront() {
    var response = this.http.get<Storefront>(`${this.BASE_URL}api/storefronts/active`);
    response
      .pipe(
        take(1),
        tap(storefront => this.ActiveStorefront.set(storefront))
      )
      .subscribe();

    return response;
  }
}
